export const checkIfURL = (url: string) => {
  const urlOrPathRegex = /^(http|https)/;

  if (urlOrPathRegex.test(url)) {
    return true;
  }

  return false;
};
